import { useDocumentExtractedData } from './use-document-extracted-data'

export function useDocumentExtractedDenialData({ documentKey }: { documentKey: string }) {
  const { data } = useDocumentExtractedData({ documentKey })

  return {
    data: data.items.filter((item) => item.type === 'denial')[0],
  }
}
